import { DataTableCol } from "../../../components/data-table/types";

export const AdvertisersGridCols: DataTableCol[] = [
  {
    title: "Code",
    control: "code",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Api key",
    control: "apikey",
    isHideAndShow: true,
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Publisher Id",
    control: "uuid",
    isHideAndShow: true,
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Status",
    control: "status",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Actions",
    control: "actions",
    sortable: false,
    isDelete: true,
    isEdit: true,
    isView: false,
    canShowColumn: true,
  },
];
